module.exports = __webpack_public_path__ + "static/media/Shan Zhang.9faf2110.png";